import { Autocomplete, TextField, Box, Card, CardContent, Tab, Tabs, useMediaQuery } from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useState, useEffect } from 'react';
import CurrentOpenings from '../currentOpenings/index';
import Screening from 'layouts/recruitement/screening';
import Candidates from 'layouts/recruitement/candidates';
import Interviews from 'layouts/recruitement/interview';
import JobOffer from 'layouts/recruitement/jobOffer';
import { useTheme } from '@emotion/react';
import Setting from '../setting';
import colors from 'assets/theme/base/colors';
import MDBox from 'components/MDBox';
import { FileUpload, PersonSearch } from '@mui/icons-material';
import MDTypography from 'components/MDTypography';
import rgba from 'assets/theme/functions/rgba';
import tab from 'assets/theme/components/tabs/tab';
import { useNavigate, useParams } from "react-router-dom";

function Recruitment(props) {
    const { modulePermissions, permissions } = props;
		const navigate = useNavigate();
    const { tab } = useParams();

		const [tabComponents, setTabComponents] = useState([]);
		const [selectedTab, setSelectedTab] = useState(null);
		
	useEffect(() => {
		const tabs = [
			{
				label: "Current Openings",
				key: "current_openings",
				component: <CurrentOpenings modulePermissions={modulePermissions} permissions={permissions} />,
			},

			permissions?.includes(modulePermissions?.candidate?.list_permission)
				? {
					label: "Candidates",
					key: "candidates",
					component: <Candidates modulePermissions={modulePermissions.candidate} permissions={permissions} />,
				}
				: null,

			permissions?.includes(modulePermissions?.interview?.list_permission)
				? {
					label: "Interviews",
					key: "interviews",
					component: <Interviews modulePermissions={modulePermissions.interview} permissions={permissions} />,
				}
				: null,

			permissions?.includes(modulePermissions?.jobOffer?.list_permission)
				? {
					label: "Job Offers",
					key: "job_offers",
					component: <JobOffer modulePermissions={modulePermissions.jobOffer} permissions={permissions} />,
				}
				: null,
		].filter(Boolean);

		setTabComponents(tabs);

	}, [permissions, modulePermissions]);


	useEffect(() => {
  if (!tabComponents.length) return;

  //If no tab in URL → set default
  if (!tab) {
    navigate("/recruitement/current_openings", { replace: true });
    return;
  }

  // 👉 Match tab from URL
  const matched = tabComponents.find(t => t.key === tab);

  if (matched) {
    setSelectedTab(matched);
  } else {
    // 👉 fallback if invalid URL
    navigate("/recruitement/current_openings", { replace: true });
  }

}, [tab, tabComponents]);

    return (
			<DashboardLayout>
				<DashboardNavbar />
				<Card sx={{ padding: 2, height: "100%" }}>
					<MDBox style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginTop: 6, marginBottom: 6 }}>
						<MDBox sx={{display : "flex", alignItem : "center", gap : 3}}>
						<MDBox
							sx={{
								width: 48,
								height: 48,
								borderRadius: "16px",
								display: "grid",
								placeItems: "center",
								background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
								color: colors.white.main,
							}}
						>
							<PersonSearch />
						</MDBox>
						<MDBox>
							<MDTypography variant="h4">Talent Acquisition</MDTypography>
							<MDTypography variant="body2" color="text">
								Track candidates, manage pipelines, and build a strong workforce with ease.
							</MDTypography>
						</MDBox>
						</MDBox>
						<MDBox>
							<Autocomplete
								disablePortal
								fullWidth
								sx={{ width: 300, marginRight: 2 }}
								options={tabComponents}
								getOptionLabel={(option) => option.label}
								value={selectedTab}
								//onChange={(event, newValue) => setSelectedTab(newValue)}
								onChange={(event, newValue) => {
									setSelectedTab(newValue);

									if (newValue?.key) {
										navigate(`/recruitement/${newValue.key}`);
									}
								}}
								renderInput={(params) => (
									<TextField {...params} label="Select Tab" variant="outlined" />
								)}
							/>
						</MDBox>
					</MDBox>
					{/* Render tab content */}
					<Box sx={{ marginTop: 2 }}>
						{selectedTab?.component}
					</Box>
				</Card>
			</DashboardLayout>
    );
}

export default Recruitment;